<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <span :id="hintId" class="govuk-hint govuk-!-padding-left-3" v-html="displayHint"> </span>
      <span :id="titleId" class="govuk-title" v-html="displayTitle"></span>

      <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
      <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

      <span :id="errorId" class="govuk-error-message">
        <ul v-if="currentErrors.length > 0">
          <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
            {{ errorMessage.message }}
          </li>
        </ul>
      </span>
      <div class="govuk-checkboxes">
        <div class="govuk-checkboxes__item">
          <input
            class="govuk-checkboxes__input"
            :id="controlId"
            :name="controlId"
            type="checkbox"
            v-model="state.checked"
            v-on:change="changeEvent()"
          />
          <label class="govuk-label govuk-checkboxes__label" :for="controlId" v-show="!state.hiddenLabel">
            {{ displayName }}
          </label>
        </div>
      </div>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/CheckBox.ts"></script>
